import React, { useRef } from 'react'
import { Link, navigate } from 'gatsby'
import { Tabs, TabPanel, Row } from '@paypalcorp/pp-react'
import { record } from '@paypalcorp/fpti'
import cln from 'classnames'

import { useSectionInViewContext } from '../../../context/SectionInViewContext'

const navItems = [
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Set up accounts',
    url: '#link-setupyouraccounttoacceptcardpayments',
  },
  {
    label: 'Generate token',
    url: '#link-generateclienttoken',
  },
  {
    label: 'Render SDK',
    url: '#link-renderjavascriptsdkandpaypalbuttons',
  },
  {
    label: 'Orders API',
    url: '#link-calltheordersapi',
  },
  {
    label: 'Add cards',
    url: '#link-addcardformelements',
  },
  {
    label: 'Test purchases',
    url: '#link-testpurchases',
  },
]

const intAdvChkItems = [
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Integration video',
    url: '#link-integrationvideo',
  },
  {
    label: 'Before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Before integration',
    url: '#link-beforeyoubeginyourintegration',
  },
  {
    label: 'Back-end code',
    url: '#link-integratebackend',
  },
  {
    label: 'Front-end code',
    url: '#link-integratefrontend',
  },
  {
    label: 'Test integration',
    url: '#link-testintegration',
  },
  {
    label: 'Go live',
    url: '#link-golive',
  },
]

const navItemsAferPayment = [
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Know before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Seller eligibility',
    url: '#link-sellereligibility',
  },
  {
    label: 'Set up webhooks',
    url: '#link-setupwebhooks',
  },
  {
    label: 'Make Payment',
    url: '#link-makepayment',
  },
  {
    label: 'Send seller signup link',
    url: '#link-sendsellersignuplink',
  },
  {
    label: 'Track seller onboarding status',
    url: '#link-trackselleronboardingstatus',
  },
  {
    label: 'Refund pending transactions',
    url: '#link-refundpendingtransactions',
  },
  {
    label: 'Next steps',
    url: '#link-nextsteps',
  },
]

const navItemsBuildOnboarding = [
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Generate signup link',
    url: '#link-generatesignuplink',
  },
  {
    label: 'Enable signup link',
    url: '#link-embedsignuplink',
  },
  {
    label: 'Redirect seller',
    url: '#link-redirectsellertoareturnurl',
  },
  {
    label: 'Get seller access token',
    url: '#link-getselleraccesstoken',
  },
  {
    label: 'Get seller Rest API credential',
    url: '#link-getsellerrestapicredentials',
  },
  {
    label: 'Next steps',
    url: '#link-nextsteps',
  },
]

const navItemsSDK = [
  {
    label: 'Add the SDK',
    url: '#link-addthesdk',
  },
  {
    label: 'Configure',
    url: '#link-configureandcustomizeyourintegration',
  },
  {
    label: 'Query parameters',
    url: '#link-queryparameters',
  },
  {
    label: 'Script parameters',
    url: '#link-scriptparameters',
  },
]

const navItemsIos = [
  {
    label: 'Know before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Integrate with card payments',
    url: '#link-integratecardpayments',
  },
  {
    label: 'Integrate with PayPal Wallet',
    url: '#link-integratepaypalwallet',
  },
  {
    label: 'Go live',
    url: '#link-golive',
  },
  {
    label: 'Next steps and customizations',
    url: '#link-nextstepsandcustomizations',
  },
]

const navItemsMultiIntegrateBefore = [
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Set up webhooks',
    url: '#link-setupwebhooks',
  },
  {
    label: 'Generate signup link',
    url: '#link-generateasignuplink',
  },
  {
    label: 'Add signup link to site',
    url: '#link-addsignuplinktoyoursite',
  },
  {
    label: 'Redirect seller to return URL',
    url: '#link-redirectsellertoareturnurl',
  },
  {
    label: 'Track seller onboarding status',
    url: '#link-trackselleronboardingstatus',
  },
  {
    label: 'Next steps',
    url: '#link-nextsteps',
  },
]

const navItemsStandard = [
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Know before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Add payment buttons',
    url: '#link-addpaymentbuttons',
  },
  {
    label: 'Test purchases',
    url: '#link-testpurchases',
  },
  {
    label: 'Next steps',
    url: '#link-nextsteps',
  },
  {
    label: 'See also',
    url: '#link-seealso',
  },
]
const navItemsStandardDocs = [
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Integration video',
    url: '#link-integrationvideo',
  },
  {
    label: 'Before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Before you begin',
    url: '#link-beforeyoubeginyourintegration',
  },
  {
    label: 'Back-end code',
    url: '#link-integratebackend',
  },
  {
    label: 'Front-end code',
    url: '#link-integratefrontend',
  },
  {
    label: 'Test integration',
    url: '#link-testintegration',
  },
  {
    label: 'Go live',
    url: '#link-golive',
  },
]

const navItemsAdvancedSDKv1 = [
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Integration video',
    url: '#link-integrationvideo',
  },
  {
    label: 'Before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Before integration',
    url: '#link-beforeyoubeginyourintegration',
  },
  {
    label: 'Back-end code',
    url: '#link-integratebackend',
  },
  {
    label: 'Front-end code',
    url: '#link-integratefrontend',
  },
  {
    label: 'Test integration',
    url: '#link-testintegration',
  },
]

const navItemsApple = [
  {
    label: 'Overview',
    url: '#link-applepayintegration',
  },
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Integration video',
    url: '#link-integrationvideo',
  },
  {
    label: 'Know before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Onboard sellers',
    url: '#link-Onboardsellers',
  },
  {
    label: 'Set up your sandbox account to accept Apple Pay',
    url: '#link-setupyoursandboxaccounttoacceptapplepay',
  },
  {
    label: 'Set up your testing environment',
    url: '#link-Setupyourtestingenvironments',
  },
  {
    label: 'Create Apple Pay sandbox account',
    url: '#link-createapplepaysandboxaccount',
  },
  {
    label: 'Integrate Apple Pay checkout',
    url: '#link-integrateApplePaycheckout',
  },
  {
    label: 'Set up your Apple Pay button',
    url: '#link-SetupyourApplePaybutton',
  },
  {
    label: 'Create Apple Pay session',
    url: '#link-CreateApplePaysession',
  },
  {
    label: 'Show the payment sheet',
    url: '#link-Showthepaymentsheet',
  },
  {
    label: 'Test your integration',
    url: '#link-Testyourintegration',
  },
  {
    label: 'Go live',
    url: '#link-Golive',
  },
  {
    label: 'Next steps & customizations',
    url: '#link-nextsteps',
  },
]

const navItemsGoogle = [
  {
    label: 'Overview',
    url: '#link-googlepayintegration',
  },
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Know before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Onboard sellers',
    url: '#link-onboardsellersgooglepay',
  },
  {
    label: 'Setup',
    url: '#link-setupyoursandboxaccounttoacceptgooglepay',
  },
  {
    label: 'Getting started',
    url: '#link-gettingstartedinyourtestingenvironment',
  },
  {
    label: 'Integrate Google Pay',
    url: '#link-integrategooglepaycheckout',
  },
  {
    label: 'Button setup',
    url: '#link-setupyourgooglepaybutton',
  },
  {
    label: 'Create payment',
    url: '#link-createpaymentdatarequest',
  },
  {
    label: 'Sample integration',
    url: '#link-putitalltogether',
  },
  {
    label: 'SCA',
    url: '#link-strongcustomerauthenticationsca',
  },
  {
    label: 'Test',
    url: '#link-testyourintegration',
  },
  {
    label: 'Go live',
    url: '#link-golive',
  },
  {
    label: 'Next steps',
    url: '#link-nextstepscustomizations',
  },
  {
    label: 'SDK API',
    url: '#link-sdkapireference',
  },
]

const navItemsAdvancedCardFieldsv1 = [
  {
    label: 'Set up event listener',
    url: '#link-setupeventlistener',
  },
  {
    label: 'Get form state',
    url: '#link-getthestateofyourform',
  },
  {
    label: 'Sample event listeners',
    url: '#link-sampleeventlisteners',
  },
  {
    label: 'Methods',
    url: '#link-methods',
  },
  {
    label: 'Type definitions',
    url: '#link-typedefinitions',
  },
]

const multiPartyAdvancedIntegration = [
  {
    label: 'How it Works',
    url: '#link-howitworks',
  },
  {
    label: 'Integration video',
    url: '#link-integrationvideo',
  },
  {
    label: 'Read the guide',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Before you begin your integration',
    url: '#link-beforeyoubeginyourintegration',
  },
  {
    label: 'Integrate front end',
    url: '#link-integratefrontend',
  },
  {
    label: 'Integrate back end',
    url: '#link-integratebackend',
  },
  {
    label: 'Test integration',
    url: '#link-testIntegration',
  },
  {
    label: 'Next steps & customizations',
    url: '#link-nextsteps',
  },
]

const navItemsCustomizeHandleErrors = [
  {
    label: 'Overview',
    url: '#link-handleerror',
  },
  {
    label: 'Know before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Buyer checkout error',
    url: '#link-buyercheckouterror',
  },
  {
    label: 'Script not loading error',
    url: '#link-scriptnotloadingerror',
  },
]

const directMerchantStdAuthCap = [
  {
    label: 'Overview',
    url: '#link-overview',
  },
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Intent',
    url: '#link-changeapprovalintent',
  },
  {
    label: 'Auth',
    url: '#link-authpayment',
  },
  {
    label: 'Capture order',
    url: '#link-captureorder',
  },
  {
    label: 'Save order',
    url: '#link-saveorder',
  },
  {
    label: 'Reauth',
    url: '#link-reauth',
  },
  {
    label: 'Capture payment',
    url: '#link-capturepayment',
  },
  {
    label: 'Next steps',
    url: '#link-nextsteps',
  },
]

const multiPartyStdAuthCap = [
  {
    label: 'Overview',
    url: '#link-overview',
  },
  {
    label: 'How it works',
    url: '#link-howitworks',
  },
  {
    label: 'Requirements',
    url: '#link-partnerrequirements',
  },
  {
    label: 'Before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Intent',
    url: '#link-changeapprovalintent',
  },
  {
    label: 'Order',
    url: '#link-createorder',
  },
  {
    label: 'Auth',
    url: '#link-authorder',
  },
  {
    label: 'Honor periods',
    url: '#link-honorperiods',
  },
  {
    label: 'Examples',
    url: '#link-examples',
  },
  {
    label: 'Recommendations',
    url: '#link-recommendations',
  },
  {
    label: 'Next steps',
    url: '#link-nextsteps',
  },
]

const navItemsStandardCheckoutCustomShipping = [
  {
    label: 'Overview',
    url: '#link-overview',
  },
  {
    label: 'Before you code',
    url: '#link-knowbeforeyoucode',
  },
  {
    label: 'Shipping options',
    url: '#link-shippingoptionschanges',
  },
  {
    label: 'Address changes',
    url: '#link-shippingaddresschanges',
  },
  {
    label: 'Next steps',
    url: '#link-nextsteps',
  },
]

export default function NavigationTabs({
  pageName,
  buttonSizes = 'normal',
}: any) {
  const { visibleSection, setVisibleSection } = useSectionInViewContext()
  const fptiData = typeof window !== `undefined` && window.fpti
  const dataSet: any =
    (
      {
        ios: navItemsIos,
        applePay: navItemsApple,
        googlePay: navItemsGoogle,
        sdk: navItemsSDK,
        multiIntegrateBefore: navItemsMultiIntegrateBefore,
        integrateStandardCheckout: navItemsStandard,
        integrateStandardCheckoutDocs: navItemsStandardDocs,
        integrateAdvancedCheckoutSDKv1: navItemsAdvancedSDKv1,
        integrateAdvancedCheckoutCardFieldsv1: navItemsAdvancedCardFieldsv1,
        buildOnboarding: navItemsBuildOnboarding,
        afterPayment: navItemsAferPayment,
        dmstdauthcap: directMerchantStdAuthCap,
        mppstdauthcap: multiPartyStdAuthCap,
        multiPartyAdvancedIntegration,
        customizehandleerrors: navItemsCustomizeHandleErrors,
        standardCheckoutShippingOptions: navItemsStandardCheckoutCustomShipping,
      } as any
    )[pageName] || navItems

  // const dataSet = pageName === 'ios' ? navItemsIos : navItems
  const selectedIndex = dataSet.findIndex((item) => item.url === visibleSection)

  const handleClick = (value: string) => {
    if (fptiData) {
      record({
        data: {
          page: fptiData.page,
          pgrp: fptiData.page,
          e: 'cl',
          link: value,
        },
      })
    }
  }

  return (
    <div className="navigationWrapper">
      <Tabs
        name="TabsGroup1"
        className={`navTabs-ppui ${
          buttonSizes === 'large' ? 'largeButtons' : ''
        }`}
        selectedTabIdx={selectedIndex}
        tabs={dataSet.map((item) => ({
          label: item.label,
          id: item.url,
          panelId: item.url,
        }))}
        onClick={(e, index) => {
          setVisibleSection(dataSet[index].url)
          handleClick(dataSet[index].label)
          navigate(dataSet[index].url)
        }}
      >
        {dataSet.map((item) => (
          <TabPanel
            key={item.url}
            id={item.url}
            tabId={item.url}
            className="multipartyTabs"
          />
        ))}
      </Tabs>
    </div>
  )
}
